import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * React Router doesn't reset scroll position on navigation the way a
 * traditional multi-page site does - without this, navigating to a new
 * page while scrolled down on the previous one leaves the new page
 * scrolled down too. Mounted once inside the router; runs on every
 * pathname change.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
